import {Component, Input} from '@angular/core';
import {WidgetModel} from '../../../model/widget.model';
@Component({
    selector: 'app-crm-task-filter-widget.settings',
    templateUrl: './crm-task-filter-widget.settings.component.html',
    styleUrl: './crm-task-filter-widget.settings.component.scss'
})
export class AppTaskFilterWidgetSettingsComponent {
    @Input() widget: WidgetModel;
    changeSettings(optionDictKey: string, target: any, widget: WidgetModel, subTarget?: string): void {
        let targetValue = target;

        widget.options_dict = widget.options_dict ? widget.options_dict : [];

        const newOption = {
            board: subTarget ? subTarget : null,
            counter_key: targetValue,
            counter_name: optionDictKey,
        };

        const foundOption = widget.options_dict.find(x => JSON.stringify(x) === JSON.stringify(newOption));

        if (foundOption) {
            widget.options_dict = widget.options_dict.filter(x => JSON.stringify(x) !== JSON.stringify(newOption));
        } else {
            widget.options_dict.push(newOption);
        }
    }

    checkContainsInTaskFilterWidget(optionDictKey: string, target: any, widget: WidgetModel, subTarget?: string): boolean {
        const currentOptions = widget.options_dict ? widget.options_dict : [];

        const newOption = {
            board: subTarget ? subTarget : null,
            counter_key: target,
            counter_name: optionDictKey,
        };

        const foundOption = currentOptions.find(x => JSON.stringify(x) === JSON.stringify(newOption));
        return !!foundOption;
    }
}